<template>
    <div>
        <p class="question-number">Question {{ index }}</p>
        <p class="question-text">{{ question.question }}</p>
        <QuizQuestionResponse v-for="r in question.responses" :key="r.key" class="question-response" :response="r">
        </QuizQuestionResponse>
    </div>
</template>

<script setup>
import QuizQuestionResponse from "@/components/classroom/sidePanel/quiz/QuizQuestionResponse.vue";
import { ref, computed } from "vue";

const props = defineProps({
    question: Object,
    participants: Object,
    index: Number
});

</script>

<style lang="scss">
@import '@/styles/variables.scss';

.question {
    &-number {
        font-size: 80%;
        margin-bottom: 5px;
    }

    &-response {
        margin: 5px 0;
    }
}
</style>